<template>
  <div id="app" :class="{'open-menu': isOpenMenu, 'ru-l': langMain.lang === 'ru'}" class="app-container">
    <div :class="{showLoader: loading}" id='loader'>
      <img width='70' src="../../public/assets/images/loading.gif" alt="">
    </div>

    <header class="header">
      <a class="header-logo-link" :href="baseUrl + 'index.html'">
        <img class="header-logo-img" src="../../public/assets/images/logo-small.svg" alt="">
        <!-- <img class="header-logo-img" src="../../public/assets/images/logo.pn/g" alt=""> -->
        <span class="logo-text">
          <span class="logo-text__bold">BigDeal</span> Agency
        </span>
      </a>

      <div class="wrapper-menu-and-burger">
        <div class="header-burger-block">
          <div class="close-block" @click="closeWhiteRoute">
            <img src="../../public/assets/images/close-i.png" alt="">
          </div>
          <div class="header-burger-block__close-wrapper" @click="openMenu">
            <img v-if="!isOpenMenu" src="../../public/assets/images/burger.png" alt="">
          </div>
        </div>
      </div>
    </header>

    <!-- section-container START -->
    <section class="section-container">
      <div class="slider-element">
        <transition
            v-on:before-enter="beforeEnter"
            v-on:after-enter="afterEnter"
            :name="transitionName"
        >
            <router-view
                v-on:animationName="setTransitionName"
                v-on:isInsults='setInsults'
                v-on:loader="setLoader"
                v-on:isNotFound="setVisibleMenu"
                v-on:termsOpen="openTermsEtc"
                v-on:visibleInsultEvent="setVisibleInsult"
                v-on:setNextRouteBtn="setNextRouteBtnMethod"
                v-on:translateTextEventInner="setTranslateInnerTextMethod"
                v-on:translateTextEvent="setTranslateTextMethod"
                :insults="insults"
            ></router-view>
        </transition>

        <transition name="tab-toggle">
          <div class="tab-mode tab-mode_position-main just-tab tab-mode_padd-b" v-if="canVisible">
            <div class="tab-mode__tabs">
              <div @click="next('choice', 'slide-to-right', true)" class="tab-mode__tabs-item" :class="{active: isActiveTab}">01</div>
              <div @click="next('choice-hard', 'slide-to-left', true)" class="tab-mode__tabs-item" :class="{active: !isActiveTab}">02</div>
            </div>
            <div class="tab-mode-footer">
              <div class="tab-mode-footer__active-mode" v-if='isActiveTab'>{{langMain.choiceTabs.modes.easy}}</div>
              <div class="tab-mode-footer__active-mode" v-if='!isActiveTab'>{{langMain.choiceTabs.modes.hard}}</div>
              <transition name="insultsVisible">
                <div class="tab-mode-footer__checkbox" v-if="visibleInsult">
                  {{lang.route['choice'].insult}}
                  <label>
                    <input class="inp-checkbox"
                          type="checkbox"
                          v-model='insults'>
                    <div class="inp-checkbox-decor inp-checkbox-decor_margin-l">
                      <img src="../../public/assets/images/marker_icon.png" alt="">
                    </div>
                  </label>
                </div>
              </transition>
            </div>
          </div>
        </transition>

        <footer class="footer">
          <div style="display:flex;padding:0;">
            <languageSelect page="index.html#" v-bind:url-route="urlRoute" list-class="footer-lis footer-lis_marg" />

            <ul class="footer-list">
              <li class="footer-list__item">
                <span @click="openTermsEtc('cookie-policy')" class="footer-list__link">{{langMain.footerInfo.cookiesPolicy}}</span>
              </li>
              <li class="footer-list__item">
                <span @click="openTermsEtc('terms-of-use')" class="footer-list__link">{{langMain.footerInfo.terms}}</span>
              </li>
              <li class="footer-list__item">
                <span @click="openTermsEtc('privacy-policy')" class="footer-list__link">{{langMain.footerInfo.privacyPolicy}}</span>
              </li>
            </ul>
          </div>
        
          <CopyRight :lang="langMain" />

        </footer>

      </div>

      <!-- <div class="btn-next-wrapper btn-next-wrapper_fixed" v-if="isVisibleButtonsRoute">
        <div @click="goToRoute" class="button-slider button-slider_position-bottom-right button-slider_position-bottom-right-fixed">
          <img v-if='translateClassName != "step_chat"' class="close-i to-right-icon" src="../../public/assets/images/arrow_icon_white.png" alt="">
          <img v-if='translateClassName == "step_chat"' class="to-left-icon" src="../../public/assets/images/close-i.png" alt="">
        </div>
      </div>
      <div class="text-next-wrapper text-next-wrapper_fixed" v-if="isVisibleButtonsRoute">
        <div class="next-btn-info-text next-btn-info-text_position-bottom-right next-btn-info-text_position-bottom-right-fixed">
          <div class="wrapper-3D" :class="translateClassName">
            <div class="step-translate step_choice" style="transform: rotateX(0deg) translateZ(40px);">
              {{lang.route['choice'].nextButton.stepText.startText}}
                <div class="inner-wrapper-3D" :class="translateClassNameInner">
                  <span class="span-one" style="transform: rotateX(0deg) translateZ(40px);">{{lang.route['choice'].nextButton.mode.easy}}</span>
                  <span class="span-two" style="transform: rotateX(55deg) translateZ(40px);">{{lang.route['choice'].nextButton.mode.hard}}</span>
                </div>
              {{lang.route['choice'].nextButton.stepText.modeText}}
            </div>
            <div class="step-translate step_chat" style="transform: rotateX(55deg) translateZ(40px);">
              {{lang.route['choice'].nextButton.close}}
            </div>
          </div>
        </div>
      </div> -->


      <div v-if="!hideBtn" @click="LearnMore" class="btn-next-wrapper btn-next-wrapper_fixed">
        <div class="button-slider" style="bottom: 0">
          <img class="close-i to-right-icon" src="../../public/assets/images/arrow_icon_white.png" alt="">
        </div>
      </div>
      <div v-if="!hideBtn" class="text-next-wrapper learn-more-btn">
        <div class="next-btn-info-text">
          <div>
              {{lang.learnMoreTxt}}
          </div>
        </div>
      </div>

    </section>
    <!-- section-container END -->

    <aside class="aside">
      <ul class="aside-social-list">
        <li class="aside-social-list__item">
          <a class="aside-social-list__link aside-social-list__link_f" v-if="langMain.socialList.facebook.isVisible" :href="langMain.socialList.facebook.link"  target="_blank"></a>
        </li>
        <li class="aside-social-list__item">
          <a class="aside-social-list__link aside-social-list__link_vk" v-if="langMain.socialList.vk.isVisible" :href="langMain.socialList.vk.link" target="_blank"></a>
        </li>
        <li class="aside-social-list__item">
          <a class="aside-social-list__link aside-social-list__link_inst" v-if="langMain.socialList.inst.isVisible" :href="langMain.socialList.inst.link" target="_blank"></a>
        </li>
        <li class="aside-social-list__item">
          <a class="aside-social-list__link aside-social-list__link_git" v-if="langMain.socialList.git.isVisible" :href="langMain.socialList.git.link" target="_blank"></a>
        </li>
        <li class="aside-social-list__item">
          <a class="aside-social-list__link aside-social-list__link_be" v-if="langMain.socialList.be.isVisible" :href="langMain.socialList.be.link" target="_blank"></a>
        </li>
        <li class="aside-social-list__item">
          <a class="aside-social-list__link aside-social-list__link_dr" v-if="langMain.socialList.dribbble.isVisible" :href="langMain.socialList.dribbble.link" target="_blank"></a>
        </li>
      </ul>
    </aside>

  </div>
</template>

<script>
import switchClasses from '@/util/switcherClasses.js'
import languageSelect from '@/views/language-select/language-select'
import setActiveUrlRoute from '@/util/setActiveUrlRoute.js'
import {baseUrl} from '@/../vue.config'

import CopyRight from '@/components/CopyRight.vue'

export default {
  name: 'app',

  data:() => {
    return {
      baseUrl: baseUrl,
      urlRoute: String,
      transitionName: '',
      loading: true,
      isOpenMenu: false,
      insults: false,
      lastPathRoute: '/',
      hideMenuHeader: false,
      openLangOption: false,
      isActiveTab: true,
      canVisible: false,
      visibleInsult: true,
      isVisibleButtonsRoute: false,
      translateClassNameInner: 'step_one',
      translateClassName: 'step_choice',
      hideBtn: false,
      goToRouteData: {
        route: '',
        animationName: ''
      },
      goToPage: {
        can: false,
        pageName: ''
      },
      lang: '',
      langMain: ''
    }
  },

  methods: {

    next: function(to, slideName, isTabClick) {
      let routeTo = `/${to}`;
      if (this.$router.history.current.fullPath == routeTo) return;

      switchClasses({add: 'hide',remove: 'show'}, 'sectionContainer');

      this.transitionName = slideName;

      setTimeout(() => {
        this.$router.push(`/${to}`)
      }, 500);

      if(!isTabClick) return;
      this.isActiveTab ? this.isActiveTab = false : this.isActiveTab = true;
    },

    LearnMore() {
      this.loading = true;
      setTimeout(() => {
        location.assign(`${baseUrl}about.html#/`);          
      }, 700);
    },

    goToNewPage: function(page) {
      this.loading = true;
      setTimeout(() => {
        location.assign(`${baseUrl}${page}#/`);          
      }, 700);
    },

    toggleLangVisible: function() {
      this.openLangOption ? this.openLangOption = false : this.openLangOption = true; 
    },

    setTransitionName: function (data) { 
      this.transitionName = data[0];

      if(data && data[1]) {
        let dataMenu = [];
        dataMenu.push(data[1]);
        this.openMenu(dataMenu);
      }
    },

    setInsults: function(data) {
      this.insults = data[0];
    },
    
    setLoader: function(data) {
      this.loading = data[0];
    },

    hideLoader: function() {
        this.loading = false;
    },

    openMenu: function(data) {
      let isCloseTransition = data[0] && data[0].close;

      if(isCloseTransition) {
        this.isOpenMenu = false;
        this.transitionName = 'slide-to-up';
        this.$router.push(data[0].transition.to);
        return;
      }

      this.isOpenMenu = true
      this.transitionName = 'slide-to-down';
      this.lastPathRoute = this.$router.history.current.fullPath;
      this.$router.push('/menu');
    },

    openTermsEtc: function(nameRoute) {
      if(Array.isArray(nameRoute)) {
        nameRoute = nameRoute[0];
      }

      if(this.$router.history.current.fullPath.search(nameRoute) !== -1) return;
      if(!this.isOpenMenu) {
        this.lastPathRoute = this.$router.history.current.fullPath;
      }
      this.isOpenMenu = true
      this.transitionName = 'slide-to-down';
      this.$router.push(`/${nameRoute}`);
    },

    closeWhiteRoute: function() {
      this.isOpenMenu = false;
      this.$router.push(this.lastPathRoute);
      this.transitionName = 'slide-to-up';
      this.lastPathRoute = '/';
    },

    setVisibleMenu: function(data) {
      this.hideMenuHeader = data[0].is;
      this.hideBtn =  data[0].is;
    },

    setCanVisible: function() {
      let activeRoute = this.$router.history.current.fullPath;
      activeRoute = activeRoute.split('/');

      if (activeRoute[1] === "choice-hard" || activeRoute[1] === "choice") {
        this.canVisible = true;
      } else {
        this.canVisible = false;
      }
    },

    setVisibleInsult: function(data) {
      let v = data && data[0];
      this.visibleInsult = v.visible;
    },

    setVisibleButtonsRoute: function() {
      switch (this.$router.history.current.name) {
        case 'choice':
        case 'choice-hard':
        case 'chat':
              this.isVisibleButtonsRoute = true;
              switchClasses({add: 'show',remove: 'hide'}, 'app');
              break;
        default:
              this.isVisibleButtonsRoute = false;
              switchClasses({add: 'hide',remove: 'show'}, 'app');
      }
    },

    setAppClassOverflow: (isBefore) => {
      if(isBefore) {
        switchClasses({add: 'overflow',remove: 'visible'}, 'app');
      } else {
        switchClasses({add: 'visible',remove: 'overflow'}, 'app');
      }
    },

    beforeEnter: function(el) {
      setActiveUrlRoute(this);
      el.classList.remove('show');
      el.classList.add('hide');
      this.hideMenuHeader = false;
      this.setCanVisible();
      this.setAppClassOverflow(true);
    },

    afterEnter: function(el) {
      el.classList.remove('hide');
      el.classList.add('show');
      this.setVisibleButtonsRoute();
      this.setAppClassOverflow(false);
    },

    setNextRouteBtnMethod: function(data) {
      this.goToPage.can = false;

      if(data && data[0] && data[0].option) {
        this.goToRouteData.route = data[0].option.route;
        this.goToRouteData.animationName = data[0].option.animationName;
      }

      if(data && data[0] && data[0].optionPage) {
        this.goToPage.can = true;
        this.goToPage.name = data[0].optionPage.page;
      }
    },

    goToRoute: function() {
      if(!this.goToPage.can) {
        this.next(this.goToRouteData.route, this.goToRouteData.animationName);
        return;
      }

      this.goToNewPage(this.goToPage.name);
    },

    setTranslateTextMethod: function(data) {
      this.translateClassName = data && data[0];
    },

    setTranslateInnerTextMethod: function(data) {
      this.translateClassNameInner = data && data[0];
    }

  },

  created: function() {
    this.lang = this.$root.$options.LANG.INDEX;
    this.langMain = this.$root.$options.LANG;
  },

  mounted: function() {
    setActiveUrlRoute(this);

    switch (this.$router.history.current.name) {
      case 'menu':
      case 'cookie-policy':
      case 'terms-of-use':
      case 'privacy-policy': 
            this.isOpenMenu = true;
            break;
      default: console.log('did not match');
    }
    
    if (this.$router.history.current.fullPath == "/choice-hard") {
      this.isActiveTab = false;
    }

    this.setVisibleButtonsRoute();

    this.setCanVisible();

    setTimeout(() => {
      this.hideLoader();
    }, 500);
  },

  components: {
    languageSelect,
    CopyRight,
  }

}
</script>

<style lang="scss">
#loader {
  position: fixed;
  top: 0;
  left: 0;
  visibility: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  background-color: whitesmoke;
  z-index: 999999;
  transition: all .4s;
  opacity: 0;

  &.showLoader {
    visibility: visible;
    opacity: 1;
  }
}
@import '../../public/assets/fonts.css';
@import '../styles/index.scss';
@import '../styles/adaptive.scss';
.learn-more-btn {
  width: 120px; bottom: 72px;
}
@media (max-width: 1600px) {
  .learn-more-btn {
    width: 102px;
    bottom: 32px;
  }
}
@media (max-width: 1360px) {
  .learn-more-btn {
    bottom: 18px;
  }
  .btn-next-wrapper {
    width: 60px;
  }
}
@media (max-width: 1024px) {
  .learn-more-btn {
    height: 40px;
  }
}
</style>
